<template>
    <div class="relative pb-12">
        <div class="w-full h-[20rem] box-border">
            <img :src="audioBook['cover_photo_url']" class="w-full h-full"/>
        </div>
        <div class="box-border px-8 py-2">
            <h2 class="box-border py-4 text-3xl font-bold text-pink-600">
                Descrizione
            </h2>
            <div class="text-justify">
                {{ currentAudioBookDetails["description"] }}
            </div>
        </div>
        <AudioBookChapters
            class="p-4 border-box"
            @play="playChapter"
            @playedChapterId="getPlayedChapterId"
            :chapters="currentAudioBookDetails['all_chapters']"
            :updatedIndex="playingIndex"
            :currentAudioId="currentAudioBookDetails.id"
        />
        <div class="sticky z-10 w-full bottom-12">
            <AudioBookChapterPlayer
                @ended="chapterEndedHandler"
                @nextClicked="getNext"
                @prevClicked="getPrev"
                :videoUrl="currentAudioBookDetails['all_chapters'][playingIndex].book_url_details.url.url"
                :is-prev-available="playingIndex>0"
                :is-next-available="audioBook['all_chapters'].length>playingIndex"
                v-if="playingIndex>=0"
                :autoPlay="autoCheck"
                @time="secondReceived"
                :currentAudioId="currentAudioBookDetails.id"
                :updatedIndex="playingIndex"
            />
        </div>
        <section class="pt-6 pb-16 text-white bg-gray-800">
            <h2 class="p-4 text-xl font-bold text-center">
                Come hai applicato l’audiolibro sul tuo lavoro?<br>
                Mandaci una testimonianza<br>
                <span class="text-pink-600">e vinci OSM Coin</span>
            </h2>
            <form @submit.prevent="submitFeedback">   
                <div class="px-4">
                <textarea id="message" name="message" v-model="message" rows="4" class="block p-2.5 w-full text-sm text-white rounded-lg border  focus:ring-blue-500 focus:border-blue-500 bg-gray-700 border-gray-600 placeholder-gray-400  focus:ring-blue-500 focus:border-blue-500" placeholder="Descrivi la tua esperienza..."></textarea>
                <button type="submit" class="w-full p-2 mt-2 text-center text-white bg-pink-600 rounded-lg text-bold">invia</button>
                </div>
            </form>
        </section>
        <!-- assigned coin banner -->
        <div v-show="showCoinBanner" class="fixed top-0 right-0 inline-block px-8 py-4 m-3 text-teal-100 bg-teal-500 rounded-lg sm:w-4/6 md:w-2/5 animate-bounce" x-transition:enter="transition transform ease-out duration-300" x-transition:enter-start="opacity-0 translate-y-1" x-transition:enter-end="opacity-100 translate-y-0" x-transition:leave="transition transform ease-in duration-300" x-transition:leave-start="opacity-100 translate-y-0" x-transition:leave-end="opacity-0 translate-y-1">
            <div class="flex items-center p-3 bg-pink-100 border-2 border-pink-600 rounded-md shadow-lg">
                <img src="/img/osm-coin.svg" alt="coin" class="w-16 h-16 image-view">
                <div class="ml-1 text-center">
                    <h1 class="text-xl font-bold">Whoo!!</h1>
                    <p class="text-base font-semibold leading-6 text-gray-700">{{ $t('3 coins credited') }}</p>
                    <p class="text-sm leading-5 text-gray-600">{{ $t("Hai completato l'intero audio di questo libro") }}</p>
                </div>
            </div>
        </div>
        <!-- end coin banner -->
        <BottomBar :diamonds="diamonds"/>
    </div>
</template>

<script>
    import AudioBookChapters from "@/Components/AudioBookChapters.vue";
    import AudioBookChapterPlayer from "@/Components/AudioBookChapterPlayer.vue";
    import data from "../../../data/AudioBooks.json";
    import BottomBar from "@/Layouts/BottomBar";
    import axios from "axios"
    
    export default {
        components: {
            BottomBar,
            AudioBookChapters,
            AudioBookChapterPlayer
        },
        props: [
            "id",
            "diamonds",
            "audioBook",
            "allCompletedChapter"
        ],
        data() {
            return {
                currentAudioBookDetails: {},
                playingIndex: -1,
                allCompletedChaptersAsSet: new Set(),
                message: null,
                showCoinBanner: false,
                autoCheck: 0,
                changeCompletedValue: false,
                device: '',
            }
        },
        created(){
            this.getMobileOS();
        },
        methods: {
            checkDevice(){
                const ua = navigator.userAgent;
                if (/android/i.test(ua)) {
                    return "android";
                } else if (/windows/i.test(ua)) {
                    return "windows";
                } else if (/Macintosh/i.test(ua)) {
                    return "macbook";
                } else if (/linux/i.test(ua)) {
                    return "linux";
                } else if (/iPad|iPhone|iPod/i.test(ua)) {
                    return "ios";
                } 
                return "other";          
            },
            getMobileOS() {
                this.device = this.checkDevice();
            },
            // autoCheckData() {
            //     this.autoCheck = 1;
            //     this.currentAudioBookDetails['all_chapters'][this.playingIndex].isCompleted = false;
            // },
            playChapter(e) {
                if (e === this.playingIndex) {
                    return;
                }
                this.playingIndex = -1;
                setTimeout(() => {
                    this.playingIndex = e;
                }, 50)
            },
            secondReceived(value) {
                this.$cookies.set("audioId", this.currentAudioBookDetails.id)
                this.$cookies.set("chapterIndex", this.playingIndex);
                this.$cookies.set("chapterTime", value);
            },
            getPlayedChapterId(value) {
                this.$cookies.set("chapterId", value);
            },
            getNext() {
                if (this.playingIndex <= 0) {
                    return;
                }
                this.playChapter(this.playingIndex);
            },
            getPrev() {
                if (this.playingIndex < this.audioBook['all_chapters'].length) {
                    this.playChapter(this.playingIndex - 1);
                }
            },
            chapterEndedHandler() {
                const currentChapter=this.currentAudioBookDetails["all_chapters"][this.playingIndex];
                axios.patch("/audio_books/chapters/completed/" + currentChapter.id).then((response)=>{
                    if(response.data.book_completed === 'you get 3 coins') {
                        this.showCoinBanner = true;
                        setTimeout(() => {
                            this.showCoinBanner = false
                        }, 6000)
                    }
                    this.allCompletedChaptersAsSet.add(currentChapter.id);
                    this.currentAudioBookDetails["all_chapters"][this.playingIndex].isCompleted=true;
                    this.currentAudioBookDetails["all_chapters"][this.playingIndex+1].isCompleted=false;
                    if(this.device === 'ios') {
                        this.playChapter(-1);
                    } else {
                        this.autoCheck = 1;
                        this.playChapter(this.playingIndex+1);
                        this.$cookies.set("chapterIndex", this.playingIndex+1);
                        this.$cookies.set("chapterId", this.currentAudioBookDetails["all_chapters"][this.playingIndex+2].id);

                    }
                })
            },
            submitFeedback() {
            const data = new FormData()
                //data.append('video_id', this.id);
                data.append('message', this.message);
                this.$inertia.post(this.route('feedback.store'), data, {
                    onStart: () => this.sending = true,
                    onFinish: () => this.sending = false,
                })
            },
        },
        mounted() {
            this.allCompletedChapter.map((e) => {
                this.allCompletedChaptersAsSet.add(e.audio_book_chapter_id);
            });
            this.currentAudioBookDetails = this.audioBook;
            if(this.$cookies.get("audioId") !== null && this.$cookies.get("chapterId") && this.$cookies.get("chapterIndex") !== null && this.$cookies.get("chapterTime") !== null) {
                if(this.currentAudioBookDetails.id === Number(this.$cookies.get("audioId"))) {
                    this.playChapter(Number(this.$cookies.get("chapterIndex")));
                }
            }
            this.currentAudioBookDetails.all_chapters = this.currentAudioBookDetails["all_chapters"].map(el => {
                let currentChapterId = el.id;
                el.isCompleted = this.allCompletedChaptersAsSet.has(currentChapterId);
                return el;
            })
        }
    };
</script>
<style scoped>
    .image-view {
        mix-blend-mode: multiply;
		background-blend-mode: multiply
    }
</style>